import commonTools from './util'

export const checkExpired = (start, end, search) => {
    // active_end_time_ut active_start_time_ut
    // const minTime = new Date(start).getTime();
    // const maxTime = new Date(end).getTime();
    const curTime = new Date().getTime();
    let checkStart = false
    if((curTime >= active_start_time_ut && curTime <= active_end_time_ut) || !!commonTools.searchPar()[search]){
        checkStart = true
    }
    return checkStart
}